module.exports = __webpack_public_path__ + "static/fonts/Fact-Narrow.eca5d80.eot";